module.exports = __webpack_public_path__ + "img/icon-smi.759eaace.svg";